import React from "react";
import "../CSS/Features.css";
import { FaFolderOpen, FaPills, FaMapMarkedAlt, FaComments } from "react-icons/fa";

export default function Features() {
  return (
          <section className="tk-features">
          <div className="tk-feature-grid">
            <article className="tk-card">
              <div className="tk-icon">
                <FaFolderOpen />
              </div>
              <h4>Patient Records & Therapy Progress</h4>
              <p>Monitor patient data and therapy progress in real-time.</p>
            </article>
    
    
            <article className="tk-card">
              <div className="tk-icon">
                <FaMapMarkedAlt />
              </div>
              <h4>TB Transmission Risk Map (GIS)</h4>
              <p>Visualize interactive maps highlighting high-risk zones.</p>
            </article>
    
            <article className="tk-card">
              <div className="tk-icon">
                <FaComments />
              </div>
              <h4>Patient Chat Forum</h4>
              <p>Direct communication with patients for consultation and support.</p>
            </article>
          </div>
        </section>
  );
}
